// Real product renders served same-origin from /visuels (converted to WebP).
export const imgUrl = (maison, reference, suffix) =>
  `/visuels/${maison}/${reference}/${reference}--${suffix}.webp`;

// etui / duo / duo-blanc / duo-editorial / flacon-macro / etui-face are 4:5 ; plan-serre is 16:9.
export const imgDims = (suffix) =>
  suffix === "plan-serre" ? { width: 1376, height: 768 } : { width: 928, height: 1152 };
